const Banner = () => {
    return (
        <div className="mx-auto max-w-md px-4 text-center sm:max-w-3xl sm:px-6 lg:px-8 lg:max-w-7xl">
            <div className="bg-brand rounded-2xl">
                <div className="max-w-2xl mx-auto text-center py-16 px-4 sm:py-20 sm:px-6 lg:px-8">
                    <h2 className="text-3xl font-extrabold text-white sm:text-4xl">
                        <span className="block">Start using Scoutli today.</span>
                        <span className="block">Fuel up the competitive drive.</span>
                    </h2>

                    <p className="mt-4 text-lg leading-6 text-indigo-200">
                        The most powerful analytics platform built for the esports community.
                    </p>

                    <a href="/support" className="mt-8 w-full inline-flex items-center justify-center px-5 py-3 border border-transparent text-base font-medium rounded-md text-indigo-600 transition-colors bg-white hover:bg-indigo-50 sm:w-auto">
                        Request Demo
                    </a>
                </div>
            </div>
        </div>

    )
}

export default Banner;
